/*
 * @Description: 
 * @Author: Darker
 * @Date: 2024-12-21 16:21:07
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-01-10 11:11:31
 */

// 域名
export const baseUrl = '//www.51yiyue.cn'; //正式环境
// export const baseUrl = 'https://mendian.yiyue.pub'//测试环境

// let baseUrlstr = '';
// if (process.env.NODE_ENV === 'production') {
//     baseUrlstr = '//www.51yiyue.cn'
// } else {
//     baseUrlstr = 'https://test-adminall.yiyue.pub'
// }
// export const baseUrl = baseUrlstr